module.exports = __webpack_public_path__ + "assets/flags/sk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/sk.svg
// module id = 512
// module chunks = 0